'use strict';

/**
 * 第三方：lodash, $moment
 * 全局：$config
**/

import Vue from 'vue';
import App from './App';
import Error from './common/components/error-handler';
import Loading from './common/components/so-loading';
import store from './store';
import router from './router';
import VueI18n from 'vue-i18n';
import 'babel-polyfill';
Vue.component('Error', Error);
Vue.component('Loading', Loading);
/** ElementUI全部组件引入 **/
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import enLocale from 'element-ui/lib/locale/lang/en';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';

import '@/assets/css/reset.css';
import '@/assets/css/public.css';
import '@/assets/css/ts-icons.less';
import 'font-awesome/css/font-awesome.min.css';
import 'element-ui/lib/theme-chalk/display.css';

//工具
import _ from 'lodash';
Vue.prototype._ = _;
var echarts=require('echarts/lib/echarts');
require("echarts/lib/chart/pie");
require("echarts/lib/chart/bar");
require("echarts/lib/component/markPoint");
require("echarts/lib/component/markLine");
require('echarts/lib/component/tooltip');
require('echarts/lib/component/title');
// import echarts from 'echarts';
Vue.prototype.$echarts=echarts;
import moment from 'moment';
Vue.prototype.$moment = moment;
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;
// bind config
import config from './config';
Vue.prototype.$config = config;
//services
import services from './common/service';
Object.keys(services).forEach(key => {
  Vue.prototype['$'+key] = services[key];
});
//filters
import filters from './common/filters';
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});
//cookies
import VueCookies from 'vue-cookies';
Vue.use(VueCookies);
/** 国际化 **/
Vue.use(VueI18n);
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
});
import Swiper from './common/components/swiper';
Vue.use(Swiper);
const i18n = new VueI18n({
  locale: 'en',
  messages: {
    zh: Object.assign(require('@/common/lang/zh'), zhLocale),
    en: Object.assign(require('@/common/lang/en'), enLocale),
  }
});

/** 插件 **/
// Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js